import React from 'react';
import { fixDecimal } from 'App/app/cart-logic';
import { currency } from '../../config';
var DishPriceOption = function (props) {
    var priceOption = props.priceOption, _a = props.single, single = _a === void 0 ? false : _a, _b = props.showName, showName = _b === void 0 ? false : _b, _c = props.showOldPrice, showOldPrice = _c === void 0 ? false : _c;
    var price = priceOption.price, oldPrice = priceOption.oldPrice;
    var singleClass = single ? 'dish__price--single' : '';
    var name = showName ? "".concat(priceOption.name, ": ") : '';
    if (oldPrice && showOldPrice) {
        return (React.createElement("div", { className: "d-flex flex-row flex-nowrap align-items-center" },
            showName && React.createElement("div", { className: "mr-2" }, name),
            React.createElement("div", { className: "dish__price dish__price--old" }, oldPrice),
            React.createElement("div", { className: "dish__price ".concat(singleClass) },
                fixDecimal(price),
                " ",
                currency)));
    }
    return (React.createElement("div", { className: "dish__price ".concat(singleClass) },
        name,
        fixDecimal(price),
        " ",
        currency));
};
DishPriceOption.displayName = 'DishPriceOption';
export default DishPriceOption;
